module.exports = __webpack_public_path__ + "media/images/common/icon-7adaf2c9557ed75a3afe83df3f096275.svg";